<template>
  <div
    class="prod_name_detail"
    style="position: relative"
  >
    <div
      class="flx brand-detail"
      v-if="details.brandDTO && details.brandDTO.name"
      @click="openBrandList(details.brandDTO.id, details.brandDTO.name)"
    >
      <h6 class="prdt_sub_hdng">
        <p>
          <span>
            <img :src="details.brandDTO.brandLogo" /></span>&nbsp; {{ details.brandDTO.name }}
        </p>
      </h6>
    </div>
    <div class="people_purchased">{{details.productName}}</div>
    <div>
      <div class="price_value">
        <h5
          class="final_amount"
          v-if="details.sellingPrice"
        >
          <span style="font-weight:normal;font-size:1.875em">&#8377;</span>
          ​<span class="special-price">{{details.sellingPrice}}</span>
          <span
            class="sp-badge"
            style="font-size:0.875em"
          >Your Price</span>
        </h5>
        <h5
          class="greyTxt"
          v-if="details.sellingPriceWithoutDiscount"
        >
          <span style="font-weight:normal;font-size: 1.15em;">&#8377;</span>
          ​<span
            class="actual-price"
            style="font-size:1.15em"
          >{{details.sellingPriceWithoutDiscount}}</span>
          <span
            class="acp-badge"
            style="font-size:0.75em"
          >Normal Price</span>
        </h5>
        <h5
          class="greyTxt"
          v-if="parseFloat(details.mrp) > parseFloat(details.sellingPriceWithoutDiscount) && details.mrp"
        >
          <span style="font-weight:normal; font-size: 0.938em;">&#8377;</span>
          <span class="actual-price">​{{details.mrp}}</span>
          <span class="acp-badge">MRP</span>
        </h5>
      </div>
    </div>
    <router-link
      :to="{path: '/product-feedback/'+ details.sellerItemRelationshipId }"
      tag="div"
      class="comment_route"
      v-if="dispalyRatingVal.commentDTOs && dispalyRatingVal.commentDTOs.length"
    >
      <star-rating
        :read-only="true"
        :increment="0.01"
        :starSize="15"
        active-color="#138808"
        :rating="Number(dispalyRatingVal.avgRating)"
        :show-rating="false"
      ></star-rating>
      <span class="allRateValue">{{dispalyRatingVal.avgRating}} out of 5</span>
    </router-link>
    <h5
      class="extra_discount"
      v-if="details.onlineDiscount > 0 && isSnackbar"
    >{{$t('onlineDiscountOnProd',{cost:details.onlineDiscount})}}</h5>

  </div>
</template>

<script>
import StarRating from "vue-star-rating";
export default {
  name: "PrdtName",
  components: {
    StarRating,
  },
  props: {
    dataName: {
      required: true,
      type: Object,
    },
    showDiscountSnackbar: {
      type: Boolean,
    },
    cutAmountStyle: {
      required: true,
    },
    dispalyRatingVal: {
      type: Object,
    },
  },
  data() {
    return {
      details: {},
      isSnackbar: false,
      FinalAmt: "",
      ratingVal: {},
    };
  },
  watch: {
    dataName() {
      this.details = this.dataName;
    },
    showDiscountSnackbar() {
      this.isSnackbar = this.showDiscountSnackbar;
    },
    dispalyRatingVal() {
      this.ratingVal = this.dispalyRatingVal;
    },
  },
  methods: {
    openBrandList(id, brandname) {
      this.brandId = id;
      if (this.brandId != id) {
        this.$store.commit("saveCategoryFilterData", {
          catfilterProdList: {},
        });
        this.$store.commit("saveCategoriesData", {
          categoriesProdList: [],
          categoriesPageIndex: 0,
        });
        this.$store.commit("saveNewCollectionCategoriesData", {
          newCollectionCategoriesProdList: [],
          newCollectionCategoriesId: 0,
          saveRootCategoryName: "",
        });
        this.$router.push(
          "/product-by-category?type=BRAND&id=" + id + "&brandName=" + brandname
        );
      } else {
        this.$router.push(
          "/product-by-category?type=BRAND&id=" + id + "&brandName=" + brandname
        );
      }
    },
  },
  mounted() {
    this.details = this.dataName;
    this.isSnackbar = this.showDiscountSnackbar;
    this.ratingVal = this.dispalyRatingVal;
  },
};
</script>
    